import StartUpGuide from './StartUpGuide';

export default StartUpGuide;
